import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { IConfigurationProviderCategoryResponse } from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setProviderCategoryList } from "@/app_redux/reducers/slices/auth/configuration_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useConfigurationProviderCategoryListAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

      await axios
        .get(`${CONFIGURATION_APIS?.PROVIDER_CATEGORY_LIST?.baseURL}`, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IConfigurationProviderCategoryResponse>) => {
          if (res.data.status === true) {
            dispatch(
              setProviderCategoryList({
                data: res.data.data,
              }),
            );
          } else {
            toast.error("Error while fetching staff category list.");
          }
        })
        .catch((e: AxiosError) => {
          captureError(e)
          sendCurl(e.config["curlCommand"]);
        });
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        if (axiosError.code === "ERR_BAD_REQUEST") {
          toast.error("Error while fetching staff category list.");
        }
        if (axiosError.response?.status === 400) {
          toast.error(axiosError.message);
        }
        if (axiosError.response?.status === 500) {
          toast.error("Internal Server Error, Contact Tech Team.");
        }
      } else {
        toast.error("Server Error: " + error.message);
      }
    }
  }, [dispatch, configuration]);

  return execute;
};
